module.exports = __webpack_public_path__ + "media/images/Note-d249c4ecc9bf2b0cdbbc98b726cc9f7e.svg";